import { CombinedSkill } from '@common/@types/recommendations';
import { API } from 'aws-amplify';

export async function getAllCombinedSkills(): Promise<CombinedSkill[]> {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = `api/combined-skills`;
  const limit = 10000;
  let allResults: CombinedSkill[] = [];
  let offset = 0;

  try {
    while (true) {
      const myInit = {
        headers: {},
        queryStringParameters: {
          limit: limit.toString(),
          offset: offset.toString(),
        },
      };
      const response: { results: CombinedSkill[] } = await API.get(apiName, path, myInit);
      allResults = allResults.concat(response.results);
      if (response.results.length < limit) {
        break;
      }
      offset += limit;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }

  return allResults;
}
